<template>
  <div class="index container">
    <v-breadcrumbs class="d-print-none">
      <v-breadcrumbs-item :exact="true" :to="{ name: 'home', params: {} }"
        >Home</v-breadcrumbs-item
      >
      <v-breadcrumbs-divider>/</v-breadcrumbs-divider>
      <v-breadcrumbs-item
        :exact="true"
        :to="{ name: 'staff', params: {} }"
        active
      >
        Staff
      </v-breadcrumbs-item>
    </v-breadcrumbs>

    <div class="d-flex justify-space-between">
      <page-params
        pageName="staffSummary"
        vuexName="staffSummary"
        :parameters="parameters"
        :loadLatestOnMount="true"
      />
      <div class="d-print-none text-right mb-4">
        <v-btn @click="print">Print</v-btn>
        <v-btn @click="editColumns" class="ml-4">Edit Displays</v-btn>
      </div>
    </div>
    <v-divider class="d-print-none" />
    <div class="d-flex justify-center ma-2 text-h6">
      <div>
        Active Staff Summary
        <div class="text-caption text-center">
          Found {{ staffList ? staffList.length : 0 }} active staff
        </div>
      </div>
    </div>

    <div class="table-container">
      <v-data-table
        :headers="customHeaders"
        :items="filteredStaff"
        :loading="!staffProcessed"
        :disable-pagination="true"
        :hide-default-header="false"
        :hide-default-footer="true"
        :disable-sort="true"
        item-key="id"
        class="elevation-1"
        :options.sync="options"
        :key="ts"
      >
        <template v-slot:group.header="{ items }">
          <th :colspan="customHeaders.length">
            <span class="text-caption">({{ items.length }} Staff)</span>
          </th>
        </template>

        <template v-slot:item.firstName="{ item }">
          <a @click="view(item)">{{ item.firstName }} {{ hideLastName && item.lastName ? item.lastName.charAt(0).toUpperCase():item.lastName }}</a>
          <div class="text-caption font-weight-light">
            <span v-if="globalCenter && !globalCenter.id">
              {{ getCenterName(item.centerId) }} -
            </span>
            <span>
              {{ item.contactTypeName }}
              <span v-if="!item.active"><v-divider vertical />(Inactive)</span>
            </span>
          </div>
        </template>

        <template v-slot:item.requirements="{ item }">
          <v-skeleton-loader v-if="loadingRequirement" type="list-item" />
          <div v-else>
            {{ getStaffRequirementstatus(item.id) }}
          </div>
        </template>

        <template v-slot:item.lastUpdate="{ item }">
          {{ getLastUpdate(item.id) | formatDateYear }}
        </template>
      </v-data-table>
    </div>
    <confirmation-dialog ref="confirm" />
    <v-dialog persistent v-model="columnsDialog">
      <v-card class="pa-4">
        
        <v-card-text>
          <v-subheader>Displays</v-subheader>
<v-divider  class="mb-4"/>
          <v-select
            v-model="parameters.includeColumns"
            :items="defaultColumns"
            label="Default Columns"
            item-text="text"
            item-value="value"
            multiple
            clearable
            chips
            outlined
            deletable-chips
          />
          <v-select
            label="Additional Columns (Requirements)"
            v-model="reportColumns"
            :items="requirementNames"
            item-text="fullName"
            item-value="id"
            return-object
            multiple
            clearable
            chips
            outlined
            hide-details
            deletable-chips
          />
          <v-checkbox v-model="hideLastName" :value="true" label="Hide last name" />

          <v-subheader v-if="contactTypes && contactTypes.length > 0">Filters</v-subheader>
<v-divider v-if="contactTypes && contactTypes.length > 0" class="mb-4"/>
          <v-select
            v-if="contactTypes && contactTypes.length > 0"
            outlined
            label="Staff Type"
            v-model="parameters.selectedStaffTypes"
            :items="contactTypes"
            item-value="id"
            item-text="name"
            multiple
            clearable
            chips
          />
        </v-card-text>
        <v-card-actions class="justify-space-around">
          <v-btn color="primary" @click="updateStaffStatus">Done</v-btn>
          <v-btn @click="columnsDialog = false">Cancel</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import moment from "moment";
import { mapActions, mapGetters } from "vuex";
import { getStaffRequirements } from "@/services/requirement";
const ConfirmationDialog = () =>
  import("@/components/common/ConfirmationDialog.vue");
const PageParams = () =>
  import("@/components/common/PageParams.vue");

export default {
  data() {
    return {
      options: {
        //define default sorting option here.
        sortBy: [],
        sortDesc: [],
      },
      ts: Date.now(),
      columnsDialog: false,
      loadingRequirement: true,
      staffList: [],
      requirementList: [],
      contactTypes: [],
      staff2Requirements: new Map(),
      staff2LastUpdate: new Map(),
      requirementStatus: "All",
      activeOnly: false,
      hideLastName: false,
      headers: [
        {
          text: "Name",
          value: "firstName",
          align: "start",
          sortable: true,
        },
        {
          text: "Requirements",
          value: "requirements",
          align: "start",
          sortable: false,
        },
        {
          text: "Memo",
          value: "memo",
          align: "start",
          sortable: false,
        },
        {
          text: "Last Update",
          value: "lastUpdate",
          align: "start",
          sortable: true,
        },
      ],
      defaultColumns: [
        {
          text: "Requirements",
          value: "requirements",
        },
        {
          text: "Memo",
          value: "memo",
        },
        {
          text: "Last Update",
          value: "lastUpdate",
        },
      ],
      sort: {
        key: null,
      },
    };
  },
  components: {
    ConfirmationDialog,
    PageParams
  },
  computed: {
    ...mapGetters("staff", ["staffProcessed", "getStaff"]),
    ...mapGetters("auth", ["myCenters"]),
    ...mapGetters("navigation", ["isAppLoading", "globalCenter"]),
    ...mapGetters("staffSummary", ["parameters"]),
    settings() {
      return this.parameters;
    },
    requirementNames() {
      const contactTypeIds = this.contactTypes.map((c) => c.id);
      if (this.requirementList) {
        const staffRequirements = this.requirementList.filter((r) => {
          if (contactTypeIds.includes(r.contactTypeId)) {
            return true;
          }
        });
        return Array.from(
          new Set(staffRequirements.map((r) => r.name))
        ).sort();
      } else {
        return [];
      }
    },
    reportColumns: {
      get() {
        return this.parameters.customColumns;
      },
      set(value) {
        this.parameters.customColumns = value;
        // this.setCustomColumns(value);
      },
    },
    customHeaders() {
      let customHeaders = [...this.headers];
      customHeaders = customHeaders.filter((header) =>
        this.parameters.includeColumns.includes(header.value)
      );

      if (this.parameters.customColumns && this.parameters.customColumns.length > 0) {
        this.parameters.customColumns.forEach((name) => {
          const header = {
            text: name,
            value: name,
            cellClass: "custom-cell",
            sortable: true,
          };
          customHeaders.splice(1, 0, header);
        });
      }

      return customHeaders;
    },
    filteredStaff(){
      if(this.contactTypes && this.contactTypes.length > 0 && this.parameters.selectedStaffTypes && this.parameters.selectedStaffTypes.length > 0){
        return this.staffList.filter((staff) => {
          return this.parameters.selectedStaffTypes.includes(staff.contactTypeId)
        });
      }
      else{
        return this.staffList;
      }
    }
  },
  methods: {
    ...mapActions("messages", [
      "addErrorMessage",
      "addMessage",
      "addSuccessMessage",
    ]),
    ...mapActions("staff", ["fetchStaff"]),
    ...mapActions("navigation", ["hideDrawer"]),
    ...mapActions("requirement", ["fetchRequirements"]),
    ...mapActions("contactType", ["fetchContactTypes"]),

    view(item) {
      this.$router.push({ name: "staffView", params: { id: item.id } });
    },
    initSummary() {
      this.loadingRequirement = true;
      const sortBy = "firstName";
      const sortDesc = false;

      const params = {
        page: 0,
        size: 10000,
        sort: `${sortBy}${sortDesc ? ",desc" : ""}`,
        searchTerms: null,
        activeOnly: true,
      };

      this.fetchStaff(params)
        .then((response) => {
          if (response) {
            this.staffList = response.content;

            const staffIds = this.staffList.map((s) => s.id);
            this.loadStaffRequirements(staffIds)
              .then((response) => {
                this.staff2Requirements = response;
                this.updateStaffStatus();
                this.loadingRequirement = false;
              })
              .catch((error) => {
                console.error(error);
                this.addErrorMessage(
                  "Error loading requirement status for staff"
                );
                this.loadingRequirement = false;
              });

          }
        })
        .catch((error) => {
          this.loadingRequirement = false;
          this.addErrorMessage("Server response with error " + error);
        });
    },
    async loadStaffRequirements(staffIds) {
      const ids =
        staffIds && staffIds.length > 0 ? staffIds.join(",") : null;
      if (ids) {
        return getStaffRequirements(ids, true).then((response) => {
          const requirements = response.data;
          let staff2Requirements = new Map();

          if (requirements && requirements.length > 0) {
            staff2Requirements = requirements.reduce((map, r) => {
              const staffId = r.staffId;
              let completedCount = 0;
              let incompleteCount = 0;
              const statuses = r.status ? Object.values(r.status) : [];

              if (r.status) {
                completedCount = statuses.filter(
                  (s) => s.state == "completed" || s.state == "pending"
                ).length;
                incompleteCount = statuses.filter(
                  (s) => s.state == "incomplete"
                ).length;
              }

              if (map.has(staffId)) {
                map.get(staffId).completedCount += completedCount;
                map.get(staffId).incompleteCount += incompleteCount;
                map.get(staffId).requirements.push(r);
              } else {
                map.set(staffId, {
                  requirements: [r],
                  completedCount,
                  incompleteCount,
                });
              }

              // update last updated time staff
              const lastUpdate = statuses.reduce((max, s) => {
                if (s.submissionDate) {
                  const lastUpdate = this.parseISOLocalDate(s.submissionDate);
                  if (max == null || (lastUpdate && max < lastUpdate)) {
                    max = lastUpdate;
                  }
                }
                return max;
              }, null);

              const staffLastUpdate = this.staff2LastUpdate.get(staffId);
              if (
                staffLastUpdate == null ||
                (lastUpdate != null && staffLastUpdate < lastUpdate)
              ) {
                this.staff2LastUpdate.set(staffId, lastUpdate);
              }

              return map;
            }, new Map());
          }

          return staff2Requirements;
        });
      } else {
        return null;
      }
    },
    async loadContactTypes() {
      const params = { page: 0, size: 100, isStaff: true };
      await this.fetchContactTypes(params).then((response) => {
        this.contactTypes = response.content;
      });
    },
    loadAvailableRequirements() {
      const sortBy = "name";
      const sortDesc = false;
      const params = {
        page: 0,
        size: 1000,
        sort: `${sortBy}${sortDesc ? ",desc" : ""}`,
        target: null,
      };
      this.fetchRequirements(params)
        .then((response) => {
          if (response) {
            this.requirementList = response.content;
          }
        })
        .catch((error) => {
          this.addErrorMessage("Server response with error " + error);
        });
    },
    getStaffRequirementstatus(staffId) {
      if (this.staff2Requirements) {
        const status = this.staff2Requirements.get(staffId);
        if (status) {
          const totalCount = status.incompleteCount + status.completedCount;
          return `${status.completedCount} of ${totalCount} requirements completed`;
        } else {
          return "n/a";
        }
      }
    },
    getLastUpdate(staffId) {
      if (this.staff2Requirements) {
        return this.staff2LastUpdate.get(staffId);
      } else {
        return null;
      }
    },
    parseISOLocalDate(s) {
      var b = s.split(/\D/);
      return new Date(b[0], b[1] - 1, b[2]);
    },
    getCenterName(id) {
      if (this.myCenters && this.myCenters.length > 0) {
        const center = this.myCenters.find((c) => c.id == id);
        return center ? center.name : "Location N/A";
      } else {
        return "Location N/A";
      }
    },
    async print() {
      await this.hideDrawer();
      window.print();
    },
    editColumns() {
      this.loadContactTypes();
      this.loadAvailableRequirements();
      this.columnsDialog = true;
    },
    updateStaffStatus() {
      if (this.staffList && this.staffList.length > 0) {
        this.staffList.forEach((staff) => {
          if (this.parameters.customColumns && this.parameters.customColumns.length > 0) {
            this.parameters.customColumns.forEach((requirementName) => {
              //find requirements
              const staffRequirements = this.staff2Requirements.get(
                staff.id
              );
              const requirement = staffRequirements.requirements.find(
                (r) => r.name == requirementName
              );
              if (requirement) {
                let status = "";
                const keys = Object.keys(requirement.status);
                keys.forEach((key) => {
                  const s = requirement.status[key];
                  const state =
                    s.state == "completed"
                      ? "Completed"
                      : s.state == "incomplete"
                      ? "Incomplete"
                      : "";

                  if (requirement.type == "Vaccination") {
                    status += `Dose ${key} `;
                  }

                  if (s.waived) {
                    status += "Waived";
                  } else {
                    if (
                      requirement.type == "Certification" &&
                      s.state == "completed"
                    ) {
                      const certificateExpiresOn = moment(s.cerfExpireDate);
                      const expired = certificateExpiresOn.isBefore(moment());
                      status += expired ? "Expired" : state;
                    } else {
                      status += state;
                    }
                  }

                  if (
                    requirement.type == "Certification" &&
                    s.state == "completed" &&
                    !s.waived
                  ) {
                    status += `\n${this.$options.filters.formatDateYear(
                      s.cerfIssueDate
                    )} - ${this.$options.filters.formatDateYear(
                      s.cerfExpireDate
                    )}`;
                  }
                  status += "\n";
                });
                staff[requirementName] = status;
              } else {
                staff[requirementName] = "n/a";
              }
            });
          }
        });

        this.ts = Date.now();
        this.columnsDialog = false;
      }
    },
  },
  mounted() {
    this.initSummary();
  },
};
</script>

<style>
.custom-cell {
  white-space: pre !important;
}
</style>